import axios from 'axios';
import cfac22 from '../../cfac22';

export const linkGuest = async () => {
  const { data } = await axios.post(
    `${cfac22('MICROSERVICES')}/auth/guest/link`,
    {},
    {
      withCredentials: true,
      headers: {
        'Full-Url': window.location.href,
      },
    }
  );

  const { success, result, error } = data;

  if (!success) {
    throw new Error(error || 'Erro ao vincular convidado');
  }

  // result: { linked: boolean, linkedId: string, message: string }
  return result;
};
